import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { getIsCurrentUserAuthorOf } from '../../redux/deviations/selectors';
import { editDeviation } from '../../redux/deviations/actionCreators';
import { Props } from './EditTierButton';

type StateProps = Pick<Props, 'isOwner'>;
type DispatchProps = Pick<Props, 'onClick'>;
type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, any> = (state, { tier }) => {
  return {
    isOwner: getIsCurrentUserAuthorOf(state, tier),
  };
};

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = (
  dispatch,
  { tier: deviation }
) => ({
  onClick: () => dispatch(editDeviation({ deviation })),
});

export default connect(mapStateToProps, mapDispatchToProps);
